export const CONTACT = {
  business: "treffe",
  legal: "3F — Centro di Formazione",
  owner: "Dott.ssa Simona De Vecchis",
  owner2: "Dott.ssa Emanuela Schietroma",
  address: "Via Baden Powell 2",
  city: "03100 Frosinone (FR)",
  venueAddress: "Viale Tevere 8/A",
  venueCity: "03100 Frosinone (FR)",
  piva: "02836790606",
  cf: "DVCSMN71A60L025F",
  phone: "+393396440792",
  phoneDisplay: "339 6440792",
  phone2: "+393334878644",
  phone2Display: "333 4878644",
  whatsapp: "393396440792",
  landline: "+3907751433967",
  landlineDisplay: "0775 1433967",
  email: "formazione@treffe.info",
  instagram: "https://www.instagram.com/treffe.formazione/",
  facebook: "https://www.facebook.com/3fcentroformazione/?locale=it_IT",
  maps: "https://www.google.com/maps/search/?api=1&query=Viale+Tevere+8/A+03100+Frosinone",
  directions: "https://www.google.com/maps/dir/?api=1&destination=Viale+Tevere+8/A,+03100+Frosinone+FR",
  googleReviews: "https://www.google.com/maps/place//data=!4m2!3m1!1s0x13255b715cdfc0d3:0xe1b814da4ff6516b",
  hours: "Lun–Ven 9:00–13:00 / 14:00–18:00 · Sab e Dom chiuso",
};

export const CREDIT = {
  name: "BC Next",
  url: "https://bcnext.it/",
};

export const IMAGES = {
  heroPrimary:
    "https://images.unsplash.com/photo-1622551546704-36926ae49878?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  heroSecondary:
    "https://images.unsplash.com/photo-1755549746560-f56c7bd0c82f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  manifesto:
    "https://images.unsplash.com/photo-1649260257620-3fd04e1952e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery: [
    "/gallery/cpr.jpg",
    "/gallery/aula.jpg",
    "/gallery/dae.jpg",
    "/gallery/cpr-esterno.jpg",
  ],
};

// Prezzi rimossi dal sito — costi e disponibilità vengono inviati via email dopo la richiesta
export const COURSES = [
  {
    id: "sicurezza-lavoro",
    tag: "Su misura",
    featured: false,
    title: "Sicurezza sul Lavoro",
    subtitle: "D.Lgs 81/08 · Figure della sicurezza",
    duration: "Su misura",
    level: "Aziende · Dipendenti",
    image: "/gallery/aula-azienda.jpg",
    description:
      "Corsi di formazione e aggiornamento per aziende e lavoratori, ai sensi del D.Lgs 81/08, pensati per garantire competenza, consapevolezza e conformità agli obblighi in materia di salute e sicurezza sul lavoro.",
    points: [
      "Formazione dei lavoratori",
      "Datori di lavoro e RSPP",
      "RSPP e ASPP",
      "Preposti e dirigenti",
      "RLS — Rappresentante dei Lavoratori per la Sicurezza",
    ],
  },
  {
    id: "antincendio-primo-soccorso",
    tag: "Obbligo di legge",
    featured: false,
    title: "Antincendio e Primo Soccorso",
    subtitle: "Gestione delle emergenze aziendali",
    duration: "Su misura",
    level: "Addetti alle emergenze",
    image: "/gallery/antincendio.jpg",
    description:
      "Corsi di formazione e aggiornamento per addetti alla gestione delle emergenze aziendali: prevenzione e gestione del rischio incendio e procedure di primo soccorso, secondo il D.Lgs. 81/08, con programmi differenziati per livello di rischio.",
    points: [
      "Antincendio: livello 1, 2 e 3",
      "Aggiornamento Antincendio liv. 1-2-3",
      "Primo Soccorso e aggiornamento",
      "Esame presso i Vigili del Fuoco per idoneità tecnica",
    ],
  },
  {
    id: "bls-d",
    tag: "Più richiesto",
    featured: true,
    title: "BLS-D Laico",
    subtitle: "Basic Life Support & Defibrillazione",
    duration: "5–6 ore",
    level: "Base · Operatori laici",
    image: "/gallery/blsd.jpg",
    description:
      "Tecniche di rianimazione cardio polmonare e abilitazione all'uso del defibrillatore per adulto e pediatrico. Certificazione ARES 118 e AHA, validità 2 anni.",
    points: [
      "Riconoscere l'arresto cardiaco improvviso",
      "Manovre RCP su adulto, bambino e infante",
      "Utilizzo del defibrillatore (DAE)",
      "Manovre di disostruzione delle vie aeree",
    ],
  },
  {
    id: "blsd-sanitario",
    tag: "Operatori sanitari",
    featured: false,
    title: "BLS(D) Sanitario",
    subtitle: "Standard American Heart Association",
    duration: "Su misura",
    level: "Operatori sanitari",
    image: "/gallery/braccio.jpg",
    description:
      "Percorso formativo teorico e pratico rivolto agli operatori sanitari e ai professionisti che necessitano di acquisire o aggiornare le competenze per intervenire tempestivamente in caso di arresto cardiaco, con tecniche di rianimazione cardiopolmonare e utilizzo del defibrillatore.",
    points: [
      "Riconoscimento dell'arresto cardiaco e attivazione dei soccorsi",
      "Tecniche di rianimazione cardiopolmonare (RCP)",
      "Utilizzo del defibrillatore semiautomatico (DAE)",
      "Procedure di intervento su adulto e pediatrico",
    ],
  },
  {
    id: "attrezzature",
    tag: "Abilitazioni",
    featured: false,
    title: "Attrezzature di Lavoro",
    subtitle: "Uso corretto e sicuro",
    duration: "Su misura",
    level: "Operatori e aziende",
    image: "/gallery/estintore.jpg",
    description:
      "Corsi di formazione e aggiornamento rivolti agli operatori e alle aziende che utilizzano attrezzature di lavoro: percorsi per un utilizzo corretto e sicuro, con competenze pratiche e consapevolezza dei rischi, nel rispetto della normativa vigente.",
    points: [
      "Carrelli elevatori",
      "Piattaforme di Lavoro Elevabili (PLE)",
      "Gru",
      "Macchine movimento terra",
    ],
  },
  {
    id: "cantieri",
    tag: "Edilizia",
    featured: false,
    title: "Cantieri e Lavori in Quota",
    subtitle: "Sicurezza in cantiere e DPI",
    duration: "Su misura",
    level: "Lavoratori e figure di cantiere",
    image: "/gallery/cantieri.jpg",
    description:
      "Corsi di formazione e aggiornamento dedicati ai lavoratori e alle figure professionali coinvolte nelle attività di cantiere e nei lavori in quota: competenze e comportamenti corretti per operare in sicurezza e prevenire i rischi.",
    points: [
      "Coordinatori per la sicurezza",
      "Formazione per lavoratori edili",
      "Ponteggi",
      "Lavori in quota",
      "Segnaletica stradale",
      "Piano Operativo di Sicurezza (POS)",
    ],
  },
  {
    id: "rischi-specifici",
    tag: "Specialistici",
    featured: false,
    title: "Rischi Specifici",
    subtitle: "Ambienti e attività lavorative",
    duration: "Su misura",
    level: "Lavoratori e aziende",
    image: "/gallery/cpr-esterno.jpg",
    description:
      "Corsi di formazione e aggiornamento dedicati alla gestione dei rischi specifici presenti nei diversi ambienti e attività lavorative, per operare in sicurezza e adottare corrette procedure operative.",
    points: [
      "Spazi confinati",
      "Rischio elettrico e PES/PAV/PEI",
      "Rischio chimico e biologico",
      "Stress lavoro correlato (linee guida INAIL)",
      "Privacy e GDPR 679",
    ],
  },
  {
    id: "sicurezza-alimentare",
    tag: "HACCP",
    featured: false,
    title: "Sicurezza Alimentare",
    subtitle: "D.Lgs 193/2007 · HACCP",
    duration: "Su misura",
    level: "Settore alimentare",
    image: "/gallery/aula.jpg",
    description:
      "Corsi di formazione e aggiornamento rivolti agli operatori del settore alimentare e alle aziende di produzione, preparazione, somministrazione e vendita di alimenti: igiene e sicurezza alimentare secondo il D.Lgs 193/2007.",
    points: [
      "HACCP per addetti alla manipolazione",
      "HACCP per responsabili",
      "Aggiornamento HACCP",
    ],
  },
  {
    id: "istruttore-aha",
    tag: "Percorso PRO",
    featured: false,
    title: "Istruttore AHA",
    subtitle: "American Heart Association",
    duration: "3 giornate",
    level: "Avanzato · Diventa docente",
    image: "/gallery/aha-card.jpg",
    description:
      "Diventa istruttore certificato American Heart Association.",
    points: [
      "Metodologia didattica AHA",
      "Sessione di monitoraggio con istruttore titolato",
      "Abilitazione all'insegnamento",
      "Materiale e certificazione digitale",
    ],
  },
];

export const BOOKING_POLICY =
  "Dal sito invii solo la richiesta di prenotazione. A seguito della richiesta, treffe ti manda una email con costi e disponibilità. Solo dopo aver allegato la ricevuta del bonifico, il partecipante riceve la mail di conferma di avvenuta iscrizione con data di inizio e ulteriori dettagli.";

// Dettagli estesi per pagina corso — CONTENUTI SEGNAPOSTO da confermare col cliente
export const COURSE_DETAILS = {
  "sicurezza-lavoro": {
    long: "Percorsi formativi e aggiornamenti dedicati alla salute e sicurezza negli ambienti di lavoro, rivolti a lavoratori, datori di lavoro e alle principali figure della prevenzione aziendale, in conformità al D.Lgs. 81/08.",
    program: [
      "Formazione dei lavoratori",
      "Formazione e aggiornamento delle figure della sicurezza",
      "Corsi per attrezzature di lavoro",
      "Formazione specifica per cantieri e attività a rischio",
      "Aggiornamenti e percorsi formativi dedicati",
    ],
    objectives: [
      "Acquisire una maggiore consapevolezza dei rischi lavorativi",
      "Conoscere le principali misure di prevenzione e protezione",
      "Sviluppare comportamenti corretti e sicuri sul lavoro",
      "Assolvere agli obblighi formativi previsti dalla normativa vigente",
    ],
    popular: ["RSPP", "RLS", "Datore di lavoro", "Formazione generale e specifica per lavoratori"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [],
    reviews: [],
  },
  "antincendio-primo-soccorso": {
    long: "Percorsi formativi teorici e pratici dedicati alla gestione delle emergenze aziendali, rivolti agli addetti incaricati e a chi desidera acquisire competenze per intervenire in modo corretto e consapevole, in conformità alla normativa vigente.",
    program: [
      "Formazione e aggiornamento antincendio",
      "Formazione e aggiornamento per addetti al primo soccorso",
      "Addestramento pratico alla gestione delle emergenze",
      "Corsi dedicati alla prevenzione e gestione dei rischi",
      "Percorsi formativi specifici per aziende e attività",
    ],
    objectives: [
      "Acquisire le competenze necessarie per affrontare situazioni di emergenza",
      "Conoscere le principali procedure di prevenzione e intervento",
      "Saper adottare comportamenti corretti e tempestivi in caso di emergenza",
      "Assolvere agli obblighi formativi previsti dalla normativa vigente",
    ],
    popular: ["Antincendio livello 1-2-3", "Aggiornamento antincendio 1-2-3", "Primo soccorso", "Antincendio livello 3 con abilitazione presso Vigili del Fuoco"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [
      { iso: "2026-11-14", date: "14 Novembre 2026 · Primo Soccorso", time: "", seats: "Posti disponibili" },
      { iso: "2026-11-21", date: "21 Novembre 2026 · Antincendio", time: "", seats: "Posti disponibili" },
    ],
    reviews: [],
  },
  "bls-d": {
    long: "Percorso formativo teorico e pratico dedicato alle tecniche di rianimazione cardiopolmonare e all'utilizzo del defibrillatore, rivolto a chi desidera acquisire le competenze necessarie per intervenire in caso di emergenza, su adulto e pediatrico.",
    program: [
      "Riconoscimento dell'arresto cardiaco improvviso",
      "Tecniche di rianimazione cardiopolmonare",
      "Utilizzo del defibrillatore semiautomatico (DAE)",
      "Manovre di disostruzione delle vie aeree",
      "Procedure di intervento su adulto, bambino e infante",
    ],
    objectives: [
      "Riconoscere tempestivamente un arresto cardiaco",
      "Acquisire le principali tecniche di rianimazione cardiopolmonare",
      "Utilizzare correttamente il defibrillatore (DAE)",
      "Saper intervenire in caso di ostruzione delle vie aeree",
      "Acquisire le competenze necessarie per intervenire in situazioni di emergenza",
    ],
    kit: "Manichini e defibrillatori per la prova pratica.",
    certification: "Attestato cartaceo e/o digitale.",
    dates: [
      { iso: "2026-10-10", date: "10 Ottobre 2026", time: "08:30 – 14:30", seats: "Posti disponibili" },
      { iso: "2026-10-31", date: "31 Ottobre 2026", time: "08:30 – 14:30", seats: "Posti disponibili" },
    ],
    reviews: [
      { name: "Marco P.", rating: 5, text: "Corso pratico e coinvolgente, istruttori preparatissimi. Ora mi sento sicuro nell'usare il defibrillatore." },
      { name: "Giulia R.", rating: 5, text: "Spiegazioni chiare e tanta pratica sui manichini. Consigliatissimo!" },
    ],
  },
  "blsd-sanitario": {
    long: "Percorso formativo teorico e pratico secondo gli standard American Heart Association (AHA), dedicato all'apprendimento delle competenze fondamentali per riconoscere e gestire un arresto cardiaco e intervenire tempestivamente attraverso la rianimazione cardiopolmonare (RCP) e l'utilizzo del defibrillatore automatico esterno (DAE).",
    program: [
      "Riconoscimento dell'arresto cardiaco e valutazione della situazione",
      "Valutazione della sicurezza della scena e attivazione del sistema di emergenza",
      "Tecniche di rianimazione cardiopolmonare (RCP) di alta qualità",
      "Utilizzo del defibrillatore automatico esterno (DAE)",
      "Coordinamento delle manovre di rianimazione e lavoro in squadra",
      "Procedure di intervento secondo gli standard e le linee guida American Heart Association",
      "Addestramento pratico attraverso manichini, DAE trainer e simulazioni di emergenza",
    ],
    objectives: [
      "Riconoscere tempestivamente un arresto cardiaco e valutare la situazione",
      "Acquisire le principali tecniche di rianimazione cardiopolmonare di alta qualità",
      "Utilizzare correttamente il defibrillatore automatico esterno (DAE)",
      "Attivare correttamente il sistema di emergenza",
      "Saper intervenire in modo rapido e sicuro durante un arresto cardiaco",
      "Acquisire capacità di coordinamento e lavoro in squadra durante la rianimazione",
      "Applicare le procedure previste dagli standard American Heart Association",
      "Trasformare le conoscenze teoriche in competenze pratiche attraverso esercitazioni e simulazioni",
    ],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [
      { iso: "2026-11-28", date: "28 Novembre 2026", time: "", seats: "Posti disponibili" },
    ],
    reviews: [],
  },
  "attrezzature": {
    long: "Percorsi formativi teorici e pratici dedicati all'utilizzo sicuro delle attrezzature di lavoro, rivolti agli operatori incaricati del loro utilizzo, in conformità alla normativa vigente.",
    program: [
      "Formazione per l'utilizzo delle attrezzature di lavoro",
      "Abilitazione e formazione specifica per operatori",
      "Addestramento pratico all'utilizzo in sicurezza",
      "Aggiornamenti delle abilitazioni",
      "Percorsi formativi dedicati alle diverse tipologie di attrezzature",
    ],
    objectives: [
      "Acquisire le competenze necessarie per utilizzare le attrezzature in sicurezza",
      "Conoscere rischi, procedure e principali misure di prevenzione",
      "Sviluppare una corretta capacità operativa e di gestione dell'attrezzatura",
      "Assolvere agli obblighi formativi e di aggiornamento previsti dalla normativa vigente",
    ],
    popular: ["PLE", "Carrelli elevatori"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [],
    reviews: [],
  },
  "cantieri": {
    long: "Percorsi formativi dedicati alla sicurezza nei cantieri e alle attività svolte in quota, rivolti a lavoratori e figure coinvolte nella gestione e prevenzione dei rischi, in conformità alla normativa vigente.",
    program: [
      "Formazione specifica per attività di cantiere",
      "Formazione per lavori in quota",
      "Utilizzo sicuro dei dispositivi di protezione individuale",
      "Prevenzione e gestione dei rischi nei lavori in cantiere",
      "Aggiornamenti e percorsi formativi dedicati",
    ],
    objectives: [
      "Acquisire consapevolezza dei principali rischi presenti nei cantieri",
      "Conoscere le procedure e le misure di prevenzione e protezione",
      "Saper utilizzare correttamente i DPI e adottare comportamenti sicuri",
      "Assolvere agli obblighi formativi previsti dalla normativa vigente",
    ],
    popular: ["Lavoratori in quota + DPI III cat.", "Addetti ai ponteggi", "Preposti"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [],
    reviews: [],
  },
  "rischi-specifici": {
    long: "Percorsi formativi dedicati alla conoscenza e alla gestione dei principali rischi presenti negli ambienti di lavoro, con approfondimenti specifici in relazione alle attività e alle mansioni svolte, in conformità alla normativa vigente.",
    program: [
      "Formazione sui rischi specifici",
      "Approfondimenti sui rischi legati alle mansioni",
      "Percorsi formativi dedicati alla prevenzione e protezione",
      "Formazione specifica per attività e ambienti di lavoro",
      "Aggiornamenti e percorsi formativi dedicati",
    ],
    objectives: [
      "Riconoscere i principali rischi legati alle attività lavorative",
      "Conoscere le misure di prevenzione e protezione da adottare",
      "Sviluppare una maggiore consapevolezza nella gestione dei rischi professionali",
      "Promuovere comportamenti consapevoli e corretti durante lo svolgimento delle mansioni",
    ],
    popular: ["Stress lavoro correlato", "Rumore", "Micro-biologico", "Vibrazione"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [],
    reviews: [],
  },
  "sicurezza-alimentare": {
    long: "Percorsi formativi dedicati alla sicurezza e all'igiene degli alimenti, rivolti agli operatori del settore alimentare e alle figure coinvolte nella gestione delle attività, in conformità alla normativa vigente.",
    program: [
      "Formazione in materia di sicurezza alimentare",
      "Formazione e aggiornamento degli operatori",
      "Percorsi dedicati all'igiene e alla corretta gestione degli alimenti",
      "Formazione specifica in relazione alle attività svolte",
      "Aggiornamenti e percorsi formativi dedicati",
    ],
    objectives: [
      "Acquisire le conoscenze fondamentali in materia di sicurezza alimentare",
      "Conoscere le corrette procedure di igiene e gestione degli alimenti",
      "Prevenire i principali rischi di contaminazione alimentare",
      "Assolvere agli obblighi formativi previsti dalla normativa vigente",
    ],
    popular: ["HACCP", "Aggiornamento HACCP", "HACCP per trasportatori di alimenti", "HACCP per attività di ristorazione"],
    certification: "Attestato cartaceo e/o digitale.",
    dates: [],
    reviews: [],
  },
  "istruttore-aha": {
    long: "Il percorso per diventare istruttori AHA ha una durata che varia, in base alla disciplina, da 2 a 5 giorni (o più in caso di necessità di ripetizione del corso di monitoraggio). Un percorso completo che ti abilita all'insegnamento delle discipline BLS-D secondo gli standard American Heart Association.",
    program: [
      "Principi della didattica AHA",
      "Gestione dell'aula e degli strumenti didattici",
      "Simulazioni di insegnamento",
      "Sessione di monitoraggio con istruttore titolato",
      "Valutazione e rilascio abilitazione",
    ],
    objectives: [
      "Padroneggiare la metodologia didattica AHA",
      "Condurre in autonomia sessioni teoriche e pratiche",
      "Valutare correttamente i partecipanti",
      "Ottenere l'abilitazione ufficiale all'insegnamento",
    ],
    kit: "Materiale didattico istruttore e certificazione digitale AHA.",
    certification: "Abilitazione ufficiale come Istruttore AHA.",
    dates: [
      { iso: "2026-11-26", end: "2026-11-28", date: "26–28 Novembre 2026", time: "Full day", seats: "Su prenotazione" },
    ],
    reviews: [
      { name: "Alessandro T.", rating: 5, text: "Percorso impegnativo ma fatto benissimo. Ora insegno anch'io BLS-D." },
    ],
  },
};

// Date future: una sessione sparisce automaticamente una volta conclusa (usa la data di fine per i corsi multi-giorno)
export const upcomingDates = (courseId) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return (COURSE_DETAILS[courseId]?.dates || []).filter(
    (d) => new Date(`${d.end || d.iso}T23:59:59`) >= now
  );
};

// Il catalogo resta sempre visibile: le aree senza date in calendario sono "su misura" e si prenotano con data da concordare
export const activeCourses = () => COURSES;


export const CHAPTERS = [
  {
    num: "01",
    title: "Partner, non fornitore",
    body: "Non vendiamo un prodotto, vendiamo un servizio: affianchiamo aziende e professionisti su adeguamento normativo, formazione e aggiornamento continuo.",
  },
  {
    num: "02",
    title: "Tre F, un unico metodo",
    body: "Consulenza, certificazioni e supporto alle imprese: tre aree di competenza, un unico obiettivo. Offrire soluzioni concrete e professionali per le esigenze di ogni azienda.",
  },
  {
    num: "03",
    title: "La sicurezza, anche al femminile",
    body: "Simona e Emanuela creano un approccio umano e attento alle persone al servizio delle aziende, perché prevenire significa anche prendersi cura.",
  },
];

// Blog / news — contenuti originali a scopo informativo (non sostituiscono la formazione)
export const BLOG_POSTS = [
  {
    slug: "cos-e-il-bls-d",
    title: "Cos'è il BLS-D e perché tutti dovrebbero saperlo",
    category: "BLS-D",
    date: "10 Giu 2026",
    readTime: "4 min",
    image:
      "https://images.unsplash.com/photo-1755549746560-f56c7bd0c82f?crop=entropy&cs=srgb&fm=webp&q=80&w=1100",
    excerpt:
      "Il Basic Life Support & Defibrillation è la sequenza di manovre che, nei primi minuti di un arresto cardiaco, può davvero fare la differenza tra la vita e la morte.",
    content: [
      { p: "Ogni anno, in Italia, migliaia di persone sono colpite da un arresto cardiaco improvviso lontano dall'ospedale. Nei primi minuti la probabilità di sopravvivenza cala rapidamente: è qui che entra in gioco il BLS-D." },
      { h: "Cosa significa BLS-D" },
      { p: "BLS-D sta per Basic Life Support & Defibrillation: il supporto di base alle funzioni vitali unito all'uso precoce del defibrillatore. L'obiettivo è mantenere ossigenato il cervello con le compressioni toraciche e ripristinare un ritmo cardiaco efficace il prima possibile." },
      { h: "La catena della sopravvivenza" },
      { p: "Riconoscere l'emergenza e chiamare i soccorsi, iniziare subito la rianimazione cardiopolmonare, utilizzare il defibrillatore appena disponibile e affidare la persona ai soccorsi avanzati: sono gli anelli di una catena in cui ogni gesto conta." },
      { h: "Perché formarsi" },
      { p: "Le manovre sono semplici ma vanno apprese e provate su manichini con la guida di istruttori titolati. Un corso BLS-D dura poche ore e ti dà la sicurezza per agire senza esitazione quando serve." },
      { h: "I numeri che fanno riflettere" },
      { p: "La sopravvivenza a un arresto cardiaco extraospedaliero senza intervento cala di circa il 10% ogni minuto che passa. Con RCP precoce e defibrillazione entro pochi minuti, le probabilità possono più che triplicare. È il motivo per cui la formazione diffusa nella popolazione salva vite reali." },
      { h: "Chi dovrebbe frequentare il corso" },
      { p: "Non serve alcuna competenza medica: il BLS-D è pensato per genitori, insegnanti, allenatori, personale aziendale, addetti alla sicurezza e semplici cittadini. Ogni persona formata è un potenziale primo soccorritore nella propria comunità." },
      { h: "Ogni quanto va rinnovato" },
      { p: "La certificazione ha validità biennale: un corso di retraining periodico permette di mantenere gesti rapidi e sicuri, perché sotto stress si esegue solo ciò che si è allenati a fare." },
    ],
    related: "bls-d",
  },
  {
    slug: "come-usare-defibrillatore-dae",
    title: "Come usare un defibrillatore (DAE): la guida in 4 passi",
    category: "DAE",
    date: "3 Giu 2026",
    readTime: "3 min",
    image:
      "https://images.unsplash.com/photo-1768552570511-da7813039445?crop=entropy&cs=srgb&fm=webp&q=80&w=1100",
    excerpt:
      "Il defibrillatore semiautomatico è progettato per essere usato anche da chi non è un professionista: ti guida con la voce, passo dopo passo.",
    content: [
      { p: "Il DAE (defibrillatore automatico esterno) analizza il ritmo cardiaco e, solo se necessario, suggerisce di erogare una scarica. È pensato per essere sicuro e intuitivo." },
      { h: "1. Accendi il dispositivo" },
      { p: "Appena lo apri o lo accendi, il DAE inizia a darti istruzioni vocali: ascoltale con attenzione e seguile con calma." },
      { h: "2. Applica gli elettrodi" },
      { p: "Attacca le placche sul torace nudo e asciutto della persona, nelle posizioni indicate sulle placche stesse." },
      { h: "3. Lascia analizzare" },
      { p: "Durante l'analisi nessuno deve toccare la persona. Il dispositivo valuta il ritmo e decide se la scarica è indicata." },
      { h: "4. Eroga la scarica in sicurezza" },
      { p: "Se il DAE lo richiede, assicurati che nessuno sia a contatto e premi il pulsante. Poi riprendi subito le compressioni finché arrivano i soccorsi." },
      { h: "Sicuro anche per chi non è esperto" },
      { p: "Il defibrillatore semiautomatico non eroga mai una scarica se il ritmo non lo richiede: è impossibile 'sbagliare' danneggiando la persona. Questo lo rende adatto anche a soccorritori occasionali, sotto la guida vocale del dispositivo." },
      { h: "Dove si trovano i DAE" },
      { p: "In Italia i defibrillatori sono sempre più diffusi in luoghi pubblici, palestre, scuole, aziende e stazioni. Conoscere la posizione del DAE più vicino e saperlo usare è parte integrante di una buona cultura del soccorso." },
      { h: "Manutenzione e responsabilità" },
      { p: "Un DAE va controllato periodicamente: batteria ed elettrodi hanno una scadenza. Nei corsi impari anche come verificarne l'efficienza, così che sia sempre pronto quando serve davvero." },
    ],
    related: "dae",
  },
  {
    slug: "manovre-disostruzione-soffocamento",
    title: "Soffocamento: le manovre di disostruzione salvavita",
    category: "Primo soccorso",
    date: "27 Mag 2026",
    readTime: "4 min",
    image:
      "https://images.unsplash.com/photo-1755549746563-a7c0a391af36?crop=entropy&cs=srgb&fm=webp&q=80&w=1100",
    excerpt:
      "Un boccone di traverso può trasformarsi in un'emergenza in pochi secondi. Sapere come reagire, su adulti e bambini, è fondamentale.",
    content: [
      { p: "L'ostruzione delle vie aeree da corpo estraneo è una delle emergenze più frequenti, soprattutto a tavola e con i bambini piccoli. Riconoscerla in fretta è il primo passo." },
      { h: "Ostruzione parziale o completa" },
      { p: "Se la persona tossisce e riesce a parlare, incoraggiala a tossire. Se non emette suoni, non respira e porta le mani alla gola, l'ostruzione è completa e va trattata subito." },
      { h: "Cosa fare nell'adulto" },
      { p: "Si alternano pacche interscapolari e compressioni addominali (manovra di Heimlich) fino alla risoluzione o alla perdita di coscienza, quando si passa alla rianimazione." },
      { h: "E con bambini e lattanti" },
      { p: "Le manovre cambiano in base all'età: sui lattanti si usano pacche dorsali e compressioni toraciche. Per questo è importante frequentare un corso pratico dedicato." },
      { h: "Prevenire è meglio" },
      { p: "Tagliare il cibo in pezzi piccoli, evitare che i bambini corrano o ridano con la bocca piena e tenere lontani piccoli oggetti riduce sensibilmente il rischio. La prevenzione resta la prima forma di soccorso." },
      { h: "Cosa NON fare" },
      { p: "Evita di mettere le dita in gola alla cieca per rimuovere il corpo estraneo: rischi di spingerlo più in profondità. Segui invece la sequenza appresa nel corso, calibrata sull'età della persona." },
      { h: "Quando chiamare il 118" },
      { p: "In caso di ostruzione completa o se la persona perde conoscenza, allerta immediatamente il 118 e prosegui con le manovre. Ogni secondo è prezioso: un corso pratico ti prepara ad agire con lucidità." },
    ],
    related: "bls-d",
  },
];

